import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { ClientStore } from '@core/state/client/client.store';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';
import { ClientConfig } from '@core/models/client.model';

export const clientMetaResolver: ResolveFn<boolean> = () => {
  const meta = inject(Meta);
  const title = inject(Title);

  const clientStore = inject(ClientStore);

  // Convertimos la señal a Observable para esperar hasta que clientConfig NO sea null
  return toObservable(clientStore.clientConfig).pipe(
    filter((config) => !!config), // Espera hasta que clientSetupResolver haya llenado el store
    take(1), // Completa la suscripción para que el Resolver finalice
    map((config: ClientConfig) => {
      // client_name proviene de la shipping data del cliente y puede no existir
      // (p. ej. clientes sin dirección de envío configurada). Usamos main_title
      // como respaldo porque siempre está presente en la configuración del cliente.
      const clientName = config.client_name ?? config.main_title;

      const logoUrl = config.logo_url;

      // 1. Inyección de Título
      title.setTitle(`Portal Oficial - ${clientName}`);

      // 2. Open Graph Tags para WhatsApp
      meta.updateTag({ property: 'og:title', content: `Bienvenido a ${clientName}` });
      meta.updateTag({
        property: 'og:description',
        content: `Accede al portal personalizado de ${clientName}.`,
      });
      meta.updateTag({ property: 'og:image', content: logoUrl });
      meta.updateTag({ property: 'og:image:secure_url', content: logoUrl });
      meta.updateTag({ property: 'og:image:type', content: 'image/png' });
      meta.updateTag({ property: 'og:type', content: 'website' });

      // Twitter Fallback
      meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
      meta.updateTag({ name: 'twitter:image', content: logoUrl });

      return true;
    }),
  );
};
